module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Table",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTable
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.tableData1), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "cursor": "pointer",
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "clearFix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(item)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px",
        "display": "block",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.sName))])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(item)
        }
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%",
        "font-size": "12px"
      },
      attrs: {
        "data": item.list,
        "show-header": false
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "sColumnCode",
        "label": ""
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sColumnName",
        "label": ""
      }
    })], 1)], 1)])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Table",
      "visible": _vm.addTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sName", $$v)
      },
      expression: "form.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchemaName", $$v)
      },
      expression: "form.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSelectName", $$v)
      },
      expression: "form.sSelectName"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.queryTableColumns
    }
  }, [_vm._v("Query")])], 1), _vm._v(" "), _vm._l((_vm.form.selectColumnList), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.adddisplayname(_vm.form.selectColumnList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletedisplayname(_vm.form.selectColumnList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTable
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Table",
      "visible": _vm.viewTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.view.sName),
      callback: function($$v) {
        _vm.$set(_vm.view, "sName", $$v)
      },
      expression: "view.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.view.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view, "sSchemaName", $$v)
      },
      expression: "view.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.view.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.view, "sSelectName", $$v)
      },
      expression: "view.sSelectName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.view.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "list"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.adddisplayname(_vm.view.list)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletedisplayname(_vm.view.list, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteTable
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateTable
    }
  }, [_vm._v("Update")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Table Relation",
      "name": "second"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTableRelation
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.tableData2), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "cursor": "pointer",
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "clearFix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail2(item)
        }
      },
      slot: "header"
    }, [_c('div', [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.nSelect1Id.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-size": "16px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.nSelect1Id.sName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.nSelect2Id.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-size": "16px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.nSelect2Id.sName))])])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "padding": "0 0px"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail2(item)
        }
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%",
        "font-size": "12px"
      },
      attrs: {
        "data": item.list,
        "show-header": false
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "nSelect1Key",
        "label": "",
        "width": ""
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "nSelect1Key",
        "label": "",
        "width": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t=\n\t\t\t\t\t\t\t\t\t")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "nSelect2Key",
        "label": "",
        "width": ""
      }
    })], 1)], 1)])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Table Relation",
      "visible": _vm.addTableRelatiionFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTableRelatiionFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form2",
    attrs: {
      "model": _vm.form2,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Schema1",
      "prop": "sName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.change(1)
      }
    },
    model: {
      value: (_vm.form2.ku1),
      callback: function($$v) {
        _vm.$set(_vm.form2, "ku1", $$v)
      },
      expression: "form2.ku1"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name1",
      "prop": "nSelect1Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(1)
      }
    },
    model: {
      value: (_vm.form2.nSelect1Id),
      callback: function($$v) {
        _vm.$set(_vm.form2, "nSelect1Id", $$v)
      },
      expression: "form2.nSelect1Id"
    }
  }, _vm._l((_vm.biao1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema2",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        return _vm.change(2)
      }
    },
    model: {
      value: (_vm.form2.ku2),
      callback: function($$v) {
        _vm.$set(_vm.form2, "ku2", $$v)
      },
      expression: "form2.ku2"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name2",
      "prop": "nSelect2Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(2)
      }
    },
    model: {
      value: (_vm.form2.nSelect2Id),
      callback: function($$v) {
        _vm.$set(_vm.form2, "nSelect2Id", $$v)
      },
      expression: "form2.nSelect2Id"
    }
  }, _vm._l((_vm.biao2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.form2.selectColumnList), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Relation Colunm1.' + (index + 1),
        "prop": "selectColumnList"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect1Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect1Key", $$v)
        },
        expression: "item.nSelect1Key"
      }
    }, _vm._l((_vm.ziduan1), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("= Relation Colunm2." + _vm._s(index + 1))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect2Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect2Key", $$v)
        },
        expression: "item.nSelect2Key"
      }
    }, _vm._l((_vm.ziduan2), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addRelationCloumn(_vm.form2.selectColumnList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRelationCloumn(_vm.form2.selectColumnList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTableRelatiionFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.SaveTableRelation
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Table Relation",
      "visible": _vm.viewTableRelatiionFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewTableRelatiionFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Schema1",
      "prop": "sName"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.change(1)
      }
    },
    model: {
      value: (_vm.view2.nSelect1Id.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect1Id, "sSchemaName", $$v)
      },
      expression: "view2.nSelect1Id.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name1",
      "prop": "nSelect1Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(1)
      }
    },
    model: {
      value: (_vm.view2.nSelect1Id.nSelectId),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect1Id, "nSelectId", $$v)
      },
      expression: "view2.nSelect1Id.nSelectId"
    }
  }, _vm._l((_vm.biao1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema2",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.change(2)
      }
    },
    model: {
      value: (_vm.view2.nSelect2Id.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect2Id, "sSchemaName", $$v)
      },
      expression: "view2.nSelect2Id.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name2",
      "prop": "nSelect2Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(2)
      }
    },
    model: {
      value: (_vm.view2.nSelect2Id.nSelectId),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect2Id, "nSelectId", $$v)
      },
      expression: "view2.nSelect2Id.nSelectId"
    }
  }, _vm._l((_vm.biao2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.view2.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Relation Colunm1.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect1Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect1Key", $$v)
        },
        expression: "item.nSelect1Key"
      }
    }, _vm._l((_vm.ziduan1), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("= Relation Colunm2." + _vm._s(index + 1))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect2Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect2Key", $$v)
        },
        expression: "item.nSelect2Key"
      }
    }, _vm._l((_vm.ziduan2), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addRelationCloumn(_vm.view2.list)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRelationCloumn(_vm.view2.list, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewTableRelatiionFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.DeleteTableRelation
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.UpdateTableRelation
    }
  }, [_vm._v("Update")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Stored Procedure",
      "name": "last"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSP
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.spData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "cursor": "pointer",
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "clearFix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail3(item)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px",
        "display": "block",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.sName))])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail3(item)
        }
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%",
        "font-size": "12px"
      },
      attrs: {
        "data": item.list,
        "show-header": false
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "sColumnCode",
        "label": ""
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sColumnName",
        "label": ""
      }
    })], 1)], 1)])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Stored Procedure",
      "visible": _vm.addSPFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addSPFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form3",
    attrs: {
      "model": _vm.form3,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form3.sName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "sName", $$v)
      },
      expression: "form3.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form3.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "sSchemaName", $$v)
      },
      expression: "form3.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Stored Procedure Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form3.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "sSelectName", $$v)
      },
      expression: "form3.sSelectName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form3.spConditionList), function(item, index) {
    return _c('el-form-item', {
      key: 's1' + index,
      attrs: {
        "label": "SP Parameter Name.",
        "prop": "spConditionList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterName),
        callback: function($$v) {
          _vm.$set(item, "sParameterName", $$v)
        },
        expression: "item.sParameterName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Code.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterCode),
        callback: function($$v) {
          _vm.$set(item, "sParameterCode", $$v)
        },
        expression: "item.sParameterCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterType),
        callback: function($$v) {
          _vm.$set(item, "sParameterType", $$v)
        },
        expression: "item.sParameterType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("Required.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sRequired),
        callback: function($$v) {
          _vm.$set(item, "sRequired", $$v)
        },
        expression: "item.sRequired"
      }
    }, _vm._l((_vm.options3), function(a) {
      return _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addsppartyname(_vm.form3.spConditionList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletesppartyname(_vm.form3.spConditionList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.form3.selectColumnList), function(item, index) {
    return _c('el-form-item', {
      key: 's2' + index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addspname(_vm.form3.selectColumnList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletespname(_vm.form3.selectColumnList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addSPFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSP
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Stored Procedure",
      "visible": _vm.viewSPFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewSPFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.view3.sName),
      callback: function($$v) {
        _vm.$set(_vm.view3, "sName", $$v)
      },
      expression: "view3.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.view3.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view3, "sSchemaName", $$v)
      },
      expression: "view3.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.view3.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.view3, "sSelectName", $$v)
      },
      expression: "view3.sSelectName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.view3.spConditionList), function(item, index) {
    return _c('el-form-item', {
      key: 's1' + index,
      attrs: {
        "label": "SP Parameter Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterName),
        callback: function($$v) {
          _vm.$set(item, "sParameterName", $$v)
        },
        expression: "item.sParameterName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Code.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterCode),
        callback: function($$v) {
          _vm.$set(item, "sParameterCode", $$v)
        },
        expression: "item.sParameterCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterType),
        callback: function($$v) {
          _vm.$set(item, "sParameterType", $$v)
        },
        expression: "item.sParameterType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("Required.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sRequired),
        callback: function($$v) {
          _vm.$set(item, "sRequired", $$v)
        },
        expression: "item.sRequired"
      }
    }, _vm._l((_vm.options3), function(a) {
      return _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addsppartyname(_vm.view3.spConditionList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletesppartyname(_vm.view3.spConditionList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.view3.list), function(item, index) {
    return _c('el-form-item', {
      key: 's2' + index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "list"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.adddisplayname(_vm.view3.list)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletedisplayname(_vm.view3.list, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewSPFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteSpTable
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateSpTable
    }
  }, [_vm._v("Update")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Database",
      "name": "third"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addDataBaseFlag = true
      }
    }
  }, [_vm._v("Add Database")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData3,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.toDataDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sDatabaseIp",
      "label": "Host&Port"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sSchema",
      "label": "Schema"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sUsername",
      "label": "User Name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Database",
      "visible": _vm.addDataBaseFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addDataBaseFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "addDataBaseForm",
    attrs: {
      "model": _vm.addDataBaseForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Host&Port.",
      "prop": "sDatabaseIp"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Host&Port"
    },
    model: {
      value: (_vm.addDataBaseForm.sDatabaseIp),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sDatabaseIp", $$v)
      },
      expression: "addDataBaseForm.sDatabaseIp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Schema"
    },
    model: {
      value: (_vm.addDataBaseForm.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sSchema", $$v)
      },
      expression: "addDataBaseForm.sSchema"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Name.",
      "prop": "sUsername"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.addDataBaseForm.sUsername),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sUsername", $$v)
      },
      expression: "addDataBaseForm.sUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password.",
      "prop": "sPassword"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Password"
    },
    model: {
      value: (_vm.addDataBaseForm.sPassword),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sPassword", $$v)
      },
      expression: "addDataBaseForm.sPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDataBaseFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAddDataBaseFlag
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Database",
      "visible": _vm.editDataBaseFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDataBaseFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "editDataBaseForm",
    attrs: {
      "model": _vm.editDataBaseForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Host&Port.",
      "prop": "sDatabaseIp"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": "disabled",
      "placeholder": "Host&Port"
    },
    model: {
      value: (_vm.editDataBaseForm.sDatabaseIp),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sDatabaseIp", $$v)
      },
      expression: "editDataBaseForm.sDatabaseIp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": "disabled",
      "placeholder": "Schema"
    },
    model: {
      value: (_vm.editDataBaseForm.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sSchema", $$v)
      },
      expression: "editDataBaseForm.sSchema"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Name.",
      "prop": "sUsername"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.editDataBaseForm.sUsername),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sUsername", $$v)
      },
      expression: "editDataBaseForm.sUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password.",
      "prop": "sPassword"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Password"
    },
    model: {
      value: (_vm.editDataBaseForm.sPassword),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sPassword", $$v)
      },
      expression: "editDataBaseForm.sPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDataBaseFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEditDataBaseFlag
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39053a84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/data.vue
// module id = 667
// module chunks = 1